export default __webpack_public_path__ + "static/media/Section2-subsvg.bc387133.svg";